import { Currency } from "@inrev/common";

export type DeltaDirection = "up" | "down" | "neutral";

export type Delta =
	| { type: "percent"; percent: number; direction: DeltaDirection }
	| { type: "amount"; amount: Currency; direction: DeltaDirection };

// A percent change is meaningless across a sign flip (e.g. -$5M -> $100K),
// so the delta falls back to the actual amount changed.
export const calculateDelta = (recent: Currency, previous: Currency): Delta | null => {
	if (previous === 0) {
		return null;
	}

	const diff = Currency.subtract(recent, previous);

	if (Math.sign(recent) * Math.sign(previous) === -1) {
		return { type: "amount", amount: diff, direction: diff > 0 ? "up" : "down" };
	}

	const percent = Math.round((diff / Math.abs(previous)) * 100);

	let direction: DeltaDirection = "neutral";
	if (percent > 0) direction = "up";
	else if (percent < 0) direction = "down";

	return { type: "percent", percent, direction };
};
